<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'lg'" :centered="false" :btn_cancel="true"
    :btn_ok="true" :booTitile="true">
    <div class="modal-body">
      <CRow class="mt-0">
        <CCol class="d-flex justify-content-end align-items-center mb-2">
          <label class="mr-2 mb-0">{{ igv === 1 ? 'Con IGV' : 'Sin IGV' }}</label>
          <CSwitchVue :key="componentKey" @changeSwitch="changeSwitch" class="mx-1 pl-2 pt-2"
            :checked="igv == 1 ? true : false" color="success" variant="opposite" shape="pill" v-bind="labelIcon" />
        </CCol>
      </CRow>
      <CRow class="mt-0">
        <CCol sm="12" lg="12">
          <div v-if="!isFactura" class="d-flex align-items-center mb-1">
            <input
              type="checkbox"
              id="clienteVarios"
              v-model="clienteVarios"
              @change="mtdToggleClienteVarios"
            />
            <label for="clienteVarios" class="ml-2 mb-0" style="cursor:pointer;"><strong>Cliente varios</strong></label>
          </div>
        </CCol>
        <CCol sm="9" md="9" lg="5" xl="5" class="col-9">
          <CInput :label="isFactura ? 'RUC' : 'Documento de cliente'"
            :placeholder="isFactura ? 'Digite RUC' : 'Digite documento'" v-model="sale_new.entity_document"
            @keypress.enter="mtdDocumentClient" />
          <div v-if="
            isFactura &&
            isRUCValid &&
            this.sale_new.entity_document &&
            this.sale_new.entity_document.length !== 11
          " class="text-danger">
            El RUC debe contener solo números y hasta 11 dígitos.
          </div>
        </CCol>
        <CCol sm="3" md="3" lg="2" xl="2" class="mt-1 my-auto mx-0 col-3">
          <CButton class="w-100 mt-2" color="info" v-c-tooltip.hover="{ content: `Buscar documento` }"
            @click="mtdDocumentClient">
            <i class="fas fa-search"></i>
          </CButton>
        </CCol>
        <CCol sm="12" md="12" lg="5" xl="5">
          <CInput :label="isFactura ? 'Razón social' : 'Nombre Cliente'"
            :placeholder="isFactura ? 'Digite razón social' : 'nombre'" v-model="sale_new.entity_name" disabled />
        </CCol>
        <CCol sm="12" md="12" lg="12">
          <CInput label="Dirección / residencia " type="search" v-model="sale_new.entity_address"
            placeholder="Dirección / residencia" />
        </CCol>
        <CCol xs="12" sm="12" md="12" lg="12">
          <CInput label="Observación" type="search" v-model="sale_new.entity_obs" placeholder="Observación" />
        </CCol>
      </CRow>
      <CRow>
        <CCol lg="6">
          <label for="adjustmentOption">Tipo de descuento</label>
          <select id="adjustmentOption" v-model="option" class="form-control">
            <option v-for="(item, index) in options" :key="index" :value="item.value">
              {{ item.label }}
            </option>
          </select>
        </CCol>
        <CCol lg="6">
          <CInput label="Monto a descontar" type="number" min="0" placeholder="0.00" v-model="adjustmentAmount"
            @blur="updateAjustment" :disabled="cpAdjunstmentAmount" />
        </CCol>
      </CRow>
      <CRow>
        <CCol lg="4">
          <h6>MÉTODO DE PAGO</h6>
          <table>
            <tbody v-if="data_metodo_pago.length == 0">
              <tr>
                <td>Sin Metodos de Pago (Agregue en Mantenimiento)</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(item, index) in data_metodo_pago" :key="index">
                <td v-if="item.label != 'MIXTO'">{{ item.label }}</td>
                <td v-if="item.label != 'MIXTO'">
                  <input type="number" class="form-control" placeholder="0" v-model="item.amount"
                    @keyup="updateSelectedPayments(item)" min="0" />
                </td>
              </tr>
              <tr>
                <td>PENDIENTE COMPLETAR</td>
                <td>
                  <input class="form-control" v-model="cpPendingPayment" disabled />
                </td>
              </tr>
            </tbody>
          </table>
        </CCol>
        <div class="col-lg-8 col-12">
          <div class="row">
            <div class="col-lg-4 col-12">
              <div class="mb-3">
                <CInput label="TOT. VENTA" :value="sale.total" readonly />
              </div>
            </div>
            <div class="col-lg-4 col-12">
              <div class="mb-3">
                <CInput label="PAGADO" :value="pagoCliente" readonly />
              </div>
            </div>
            <div class="col-lg-4 col-12">
              <div class="mb-3">
                <CInput label="PENDIENTE" :value="pendiente" readonly />
              </div>
            </div>
            <div class="col-lg-4 col-12">
              <div class="mb-3">
                <CInput label="AJUSTE" :value="parseFloat(sale_new.adjustment).toFixed(2)" readonly />
              </div>
            </div>
            <CCol sm="4">
              <div class="mb-3">
                <CInput label="TOT. PAGAR" :value="pagoTotal" readonly />
              </div>
            </CCol>
            <CCol sm="4">
              <CInput label="VUELTO S/" :value="cpVuelto" readonly />
            </CCol>
            <CCol v-if="this.turned.amount > 0 && this.paymentEfectivo()" sm="12">
              <CSelect label="Método de pago del vuelto" :value.sync="turned.method" :options="turnedMethod"
                placeholder="--Seleccione un metodo--" />
            </CCol>
          </div>
        </div>
      </CRow>
    </div>
    <template #footer>
      <button @click="mtdClose" class="btn btn-danger">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </button>
      <button @click="mtd_action" :disabled="cpButton" class="btn btn-info btn-info">
        <i class="fas fa-dollar-sign"></i>Guardar venta
      </button>
      &nbsp;
    </template>
  </CModal>
</template>

<script>
import CModal from "../../../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";
import moment from "moment";
import CSwitchVue from '../../../../shared/switch/CSwitch.vue';
export default {
  name: "c-sale-modal",
  components: {
    CModal,
    CSwitchVue
  },
  data() {
    return {
      prefix: "sales",
      option: 0,
      options: [
        { label: "[Escoja una opción..]", value: 0 },
        { label: "Soles", value: 1 },
        { label: "%", value: 2 },
      ],
      adjustmentAmount: 0,
      data_comprobante_pago: [],
      data_metodo_pago: [],
      selectedPayments: [],
      sale_new: {},
      isRUCValid: true, // Variable para el estado de validación
      clienteVarios: false,
      turnedMethod: [],
      turned: {
        amount: 0,
        method: 0,
      },
      igv: 0,
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      componentKey: 0,
      // disabledButton: true
    };
  },
  props: {
    title: String,
    productList: {
      type: Array,
      required: true,
    },
    sale: {
      type: Object,
      required: true,
    },
    boo_modal: Boolean,
  },
  watch: {
    boo_modal(newVal) {
      if (newVal) {
        this.sale_new = { ...this.sale };
        this.showDocumentType();
        this.showMethodPayment();
        this.showBead();
      }
    },
  },
  computed: {
    isFactura() {
      return this.sale_new.document_type_id == 2; // Asume que el ID de Factura es 2
    },
    colClass() {
      const itemsCount = this.data_comprobante_pago.length;
      if (itemsCount === 1) return "col-12";
      if (itemsCount === 2) return "col-6";
      if (itemsCount === 3) return "col-4";
      return "col-6";
    },
    cpButton() {
      if (this.sale_new.document_type_id == 3) {
        return (!this.sale_new.document_type_id);
      } else {
        return (
          !this.sale_new.entity_document ||
          !this.sale_new.entity_name ||
          !this.sale_new.document_type_id
        );
      }
    },
    // Suma de los pagos seleccionados
    pagoCliente() {
      return parseFloat(this.sale_new.amount).toFixed(2);
    },
    // Calcular el monto pendiente a pagar
    pendiente() {
      return this.sale_new.total;
    },
    pagoTotal() {
      let tot = 0;
      tot =
        parseFloat(this.sale_new.total) + parseFloat(this.sale_new.adjustment);
      this.sale_new.pendigPayment = parseFloat(tot).toFixed(2);
      return parseFloat(tot).toFixed(2);
    },
    cpVuelto() {
      const totalPayments = this.selectedPayments.reduce(
        (sum, payment) => sum + parseFloat(payment.amount),
        0
      );
      let pend = this.pagoTotal == 0 ? this.sale_new.total : this.pagoTotal;

      if (totalPayments > 0) {
        if (parseFloat(totalPayments - pend).toFixed(2) > 0) {
          this.turned.amount = parseFloat(totalPayments - pend).toFixed(2);
          return parseFloat(totalPayments - pend).toFixed(2);
        } else {
          this.turned.amount = 0;
          return 0;
        }
      }
      this.turned.amount = 0;
      return 0;
    },
    cpPendingPayment() {
      const totalPayments = this.selectedPayments.reduce(
        (sum, payment) => sum + parseFloat(payment.amount),
        0
      );
      if (totalPayments == 0) {
        // this.disabledButton = true;
        return this.pagoTotal == 0
          ? parseFloat(this.sale_new.total).toFixed(2)
          : this.pagoTotal;
      }
      let pendientePago = parseFloat(this.sale_new.pendigPayment);

      let pagosTotales = parseFloat(totalPayments);

      let res =
        pendientePago == 0
          ? (this.sale_new.total - pagosTotales).toFixed(2)
          : (pendientePago - pagosTotales).toFixed(2);

      // this.disabledButton = res <= 0 ? false : true;
      return res < 0 ? 0 : res;
    },
    cpAdjunstmentAmount() {
      if (this.option > 0) {
        this.updateAjustment();
        return false;
      }
      this.sale_new.adjustment = 0;
      return true;
    },
  },

  methods: {
    ...mapActions(["get", "post"]),
    changeSwitch() {
      this.igv = this.igv == 0 ? 1 : 0; // Actualiza el valor de igv manualmente
    },
    mtdClose() {
      this.data_comprobante_pago = [];
      this.data_metodo_pago = [];
      this.$emit("closeModalSale");
    },
    showDocumentType() {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/byDocumentType",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          let defaultIndex = null;

          response.data.data.forEach((arr, index) => {
            const { id, name } = arr;
            const selected = name === "NOTA DE VENTA";
            if (selected) defaultIndex = id;
            this.data_comprobante_pago.push({
              label: name,
              value: id,
              selected: selected,
            });
          });

          if (defaultIndex !== null) {
            this.selectItem(defaultIndex);
          }
        })
        .catch((errors) => { });
    },
    showMethodPayment() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/byMethodPayment/" +
          this.$store.getters.get_company.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.data.forEach((arr) => {
            const { id, name } = arr;
            this.data_metodo_pago.push({
              label: name,
              value: id,
              amount: "",
            });
            this.turnedMethod.push({
              label: name,
              value: id,
            });
          });
        })
        .catch((errors) => { });
    },
    selectItem(index) {
      this.sale_new.document_type_id = index;
      this.data_comprobante_pago.forEach((item) => {
        item.selected = item.value === index;
      });

      // Resetear los valores según el tipo de comprobante seleccionado
      this.clienteVarios = false;
      if (this.isFactura) {
        this.isRUCValid = true; // Reinicia la validación del RUC
      }
      this.sale_new.entity_document = "";
      this.sale_new.entity_name = "";
    },
    updateSelectedPayments(item) {
      if (item.amount < 0) {
        item.amount = 0;
        return;
      }
      // Elimina cualquier elemento existente con el mismo ID
      if (item.amount === "" || parseFloat(item.amount) === 0) {
        this.selectedPayments = this.selectedPayments.filter(
          (payment) => payment.id !== item.value
        );
        return;
      }
      let newTotal;
      if (item.amount) {
        // Elimina cualquier elemento existente con el mismo ID
        this.selectedPayments = this.selectedPayments.filter(
          (payment) => payment.id !== item.value
        );

        newTotal =
          this.selectedPayments.reduce(
            (sum, payment) => sum + parseFloat(payment.amount),
            0
          ) + parseFloat(item.amount);
      }
      // Agregue así exceda
      if (item.amount > 0) {
        this.selectedPayments.push({
          id: item.value,
          label: item.label,
          amount: item.amount,
        });
      }
    },
    paymentEfectivo() {
      return (
        this.selectedPayments.length > 0 &&
        this.selectedPayments.every((payment) => payment.label === "EFECTIVO")
      );
    },
    mtd_action: async function () {
      let boo = this.mtdVerifDataSale();
      if (!boo) return;
      if (boo) {
        this.sale_new.date = moment().format("YYYY-MM-DD HH:mm:ss");
        this.sale_new.type = 0; //mejor hacerlo en el back
        this.sale_new.option = this.option;
        if (this.option == 1) {
          this.sale_new.adjustment = parseFloat(
            this.adjustmentAmount * -1
          ).toFixed(2);
        } else {
          const total = this.sale_new.total;
          let tempAdjustment = (total * this.adjustmentAmount) / 100;
          this.sale_new.adjustment = parseFloat(tempAdjustment * -1).toFixed(2);
        }
      }
      let resWsp = [];
      let nameWsp = "";
      let documentWsp = ""
      await this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/store",
        token: this.$store.getters.get__token,
        params: {
          sale: this.sale_new,
          saleDetail: this.productList,
          charge: this.selectedPayments,
          turned: this.turned,
          igv: this.igv
        },
      }).then((response) => {
        let color = "";
        let message = "";

        if (response.statusCode == 200 && response.data.data !== null) {
          if (response.data.state == 1 || response.data.state == 2 || response.data.state == 3) {
            message = response.message;
            Swal.fire({
              title: message,
              icon: "warning",
            });
          } else {
            color = "success";
            message = "REGISTRADO CORRECTAMENTE";
            resWsp = response;
            nameWsp = this.sale_new.entity_name;
            documentWsp = this.sale_new.entity_document;
          }
        } else {
          color = "warning";
          message = "Venta Registrada";
        }
        // Reseteamos la data
        this.resetFormData();
        this.selectedPayments = [];
        // Emit event to parent to reset productList and close modal
        this.$emit("save");
        if (color == 'success') {
          this.mtdProccessSaleResponse(resWsp, nameWsp, documentWsp, response.data.phone);
        } else {
          Swal.fire({
            title: message,
            icon: color,
          });
        }
      });
    },
    resetFormData() {
      this.sale_new = {
        id: "",
        company_id: this.$store.getters.get_company.id,
        campu_id: this.$store.getters.get_campu.id,
        user_id: this.$store.getters.get__user_id,
        document_type_id: "",
        date: "",
        type: 0,
        total: "",
        amount: 0,
        pending: 0,
        typeAjustment: 0 /** tipo de ajuste % o S/ */,
        adjustment: 0 /** monto de ajuste */,
        new_pending: "" /** pendiente luego del ajuste */,
        pendigPayment: 0,
        ruc: "",
        state: 0,
        entity_document: "",
        entity_name: "",
        entity_address: "",
        entity_obs: "",
        bead_id: "",
        option: 0,
      };
      // this.adjustmentType = 0;
      this.option = 0;
      this.adjustmentAmount = 0;
      this.clienteVarios = false;
      this.selectedPayments = [];
      this.turnedMethod = [];
      this.data_comprobante_pago = [];
      this.data_metodo_pago = [];
      this.igv = 0;
    },
    showBead() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/beads/showBead/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          let bead = response.data;
          this.sale_new.bead_id = bead.id;
        })
        .catch((errors) => { });
    },
    openTicket(id) {
      window.open(
        this.$store.getters.get__url +
        "/sales/ticket/" +
        id +
        "/" +
        this.$store.getters.get__user_id,
        "_blank"
      );
    },
    mtdDocumentClient: function () {
      if(this.sale_new.entity_document.length == 0){
        this.sale_new.entity_document = "11111111";
      }
      this.get({
        url:
          this.$store.getters.get__url +
          "/sales/cliente/" +
          this.$store.getters.get_company.id +
          "/" +
          this.sale_new.entity_document,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.data.state == 0) {
          if (
            this.sale_new.entity_document.length == 8 ||
            this.sale_new.entity_document.length == 11
          ) {
            this.mtdSearchDocument();
          } else {
            this.sale_new.entity_name = "";
          }
        } else if (response.statusCode == 200) {
          this.sale_new.entity_name = response.data.data.name;
          this.sale_new.entity_address = response.data.data.address;
        }
      });
    },
    mtdSearchDocument: async function () {
      if (this.sale_new.entity_document.length === 0) {
        this.sale_new.entity_document = "11111111";
      }

      await this.get({
        url:
          this.$store.getters.get__url +
          "/Consultas/" +
          this.sale_new.entity_document,
        token: this.$store.getters.get__token,
      }).then((response) => {
        if (response.data.boo === 3) {
          this.clearClientData();
          Swal.fire({
            title: "DNI no encontrado",
            icon: "warning",
          });
        } else {
          let name =
            this.sale_new.entity_document.length == 8
              ? response.data.name + " " + response.data.last_name
              : response.data.razon_social;
          this.sale_new.entity_name = name;
          this.sale_new.entity_address = response.data.direccion ?? "";
        }
      });
    },
    clearClientData() {
      this.sale_new.entity_document = "";
      this.sale_new.entity_name = "";
      this.sale_new.entity_address = "";
    },
    updateAjustment() {
      // this.sale_new.typeAjustment = this.adjustmentType;
      this.sale_new.adjustment = 0;
      let adjustmentAmount = parseFloat(this.adjustmentAmount) || 0;
      if (this.option == 1) {
        /** soles */
        this.sale_new.adjustment = parseFloat(adjustmentAmount * -1).toFixed(2);
      } else {
        /** % */
        const total = this.sale_new.total;
        let tempAdjustment = (total * adjustmentAmount) / 100;
        this.sale_new.adjustment = parseFloat(tempAdjustment * -1).toFixed(2);
      }
    },
    mtdToggleClienteVarios() {
      if (this.clienteVarios) {
        this.sale_new.entity_document = "11111111";
        this.mtdSearchDocument();
      } else {
        this.sale_new.entity_document = "";
        this.sale_new.entity_name = "";
        this.sale_new.entity_address = "";
      }
    },
    mtdVerifDataSale: function () {
      let boo = true;
      this.sale_new.pendingPaymentCalculated = this.cpPendingPayment;
      if (this.productList.length <= 0) {
        Swal.fire({
          title: "No tiene productos en el carrito de venta.",
          icon: "error",
        });
      }
      if (
        this.isFactura &&
        this.isRUCValid &&
        this.sale_new.entity_document &&
        this.sale_new.entity_document.length != 11
      ) {
        Swal.fire({
          title: "El RUC no es válido. Debe tener 11 dígitos.",
          icon: "error",
        });
        boo = false;
      } 
      else if (
        this.sale_new.entity_document == "" ||
        this.sale_new.entity_name == ""
      ) {
        Swal.fire({
          title: "Agregue datos del cliente",
          icon: "error",
        });
        boo = false;
      }
      if (
        this.turned.amount > 0 &&
        this.turned.method == 0 &&
        this.turned.amount
      ) {
        Swal.fire({
          title: "Agregue metodo de pago para el vuelto",
          icon: "error",
        });
        boo = false;
      }
      return boo;
    },
    mtdProccessSaleResponse: async function (response, name, document, phone) {
      const result = await Swal.fire({
        title: "Venta Finalizada",
        text: "Seleccione una opción",
        icon: "success",
        showCancelButton: true,
        showDenyButton: false,
        confirmButtonText: '<i class="fas fa-file-pdf"></i> Imprimir PDF',
        cancelButtonText: '<i class="fab fa-whatsapp"></i> Enviar a WhatsApp',
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-success",
          actions: "d-flex justify-content-between gap-2",
        },
        buttonsStyling: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: true,
        showCloseButton: true,
      });
      if (result.isConfirmed) {
        if (response.data.document_type_id == 3) {
          this.openTicket(response.data.voucher_id);
        } else {
          let res = response.data.data.sunat;
          window.open(res.json.enlace_del_pdf_ticket, "_blank");
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        // let phone = celular;
        if (!phone) {
          await Swal.fire({
            title: "No hay número registrado",
            text: "Por favor, ingresa un número de teléfono para enviar el comprobante.",
            icon: "warning",
            input: "text",
            inputPlaceholder: "Ingrese su número de teléfono",
            showCancelButton: true,
          }).then(async (inputResult) => {
            if (inputResult.isConfirmed && inputResult.value) {
              phone = inputResult.value;
            } else {
              return;
            }
          });
        } else {
          await Swal.fire({
            title: "Confirmar número de teléfono",
            text: "Por favor, revisa o edita el número de teléfono antes de enviar el comprobante.",
            icon: "info",
            input: "text",
            inputValue: phone,
            showCancelButton: true,
          }).then(async (inputResult) => {
            if (inputResult.isConfirmed && inputResult.value) {
              phone = inputResult.value;
            } else {
              return;
            }
          });
        }
        let urlPdf = "";
        let res = response.data.data.sunat;
        if (response.data.document_type_id == 3) {
          urlPdf =
            this.$store.getters.get__url +
            "/sales/ticket/" +
            response.data.voucher_id +
            "/" +
            this.$store.getters.get__user_id;
        } else {
          urlPdf = res.json.enlace_del_pdf_ticket;
        }
        await this.post({
          url: this.$store.getters.get__url + "/send/wsp/sale",
          token: this.$store.getters.get__token,
          params: {
            phone: phone,
            fileUrl: urlPdf,
            filename: `${response.data.data.serie}-${response.data.data.number}.pdf`,
            message: `Hola ${name}, te enviamos el comprobante de tu compra en *AQ Industrias*. \nGracias por tu preferencia. \n¡Quedamos atentos para cualquier consulta!.\nSaludos`,
            document: document
          },
        });

        await Swal.fire({
          title: "Mensaje enviado",
          text:
            "El comprobante electrónico se ha enviado correctamente a " + phone,
          icon: "success",
        });
      }
    },

  },
};
</script>

<style scoped>
.bg-purple {
  background-color: #926cdc;
}

.bg-white {
  background-color: white;
}

.bg-gris {
  background-color: #dee2e6;
}

.color-white {
  color: white;
}

.color-black {
  color: black;
}

.font-bold {
  font-weight: bold;
}

.container-type {
  height: 40px;
}

.container-type:hover {
  background-color: #17a2b8;
  /* bg-info */
  cursor: pointer;
}

.text {
  margin: auto;
}
</style>
